import React, { ReactElement, useCallback, useEffect, useMemo } from 'react';
import { CycleSelection } from 'screens/WidgetGenerator/components/WidgetConfig/CycleSelection';
import { ReportFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { SelectOption } from '@zencity/common-ui/lib/ZCD/ZCDFilter/types';
import { rakeWeighterExecutionLabel } from 'utils/rakeWeighterExecutions';

export const CyclesFilter = (props: ReportFilterProps<number>): ReactElement => {
  const { value, onChange, filterValues, clientData } = props;

  const rakeWeighterExecutions = useMemo(() => {
    if (!filterValues.surveyGroupId) {
      return undefined;
    }
    return clientData.rakeWeighterExecutionsBySurveyGroup[filterValues.surveyGroupId];
  }, [filterValues.surveyGroupId, clientData.rakeWeighterExecutionsBySurveyGroup]);

  const cycleOptions = useMemo<SelectOption[]>(() => {
    if (!rakeWeighterExecutions) {
      return [];
    }

    return rakeWeighterExecutions.map((rakeWeighterExecution) => ({
      value: rakeWeighterExecution.id,
      label: rakeWeighterExecutionLabel(rakeWeighterExecution),
    }));
  }, [rakeWeighterExecutions]);

  const handleCycleSelection = useCallback(
    (newValue: unknown) => {
      if (cycleOptions.length < 1) {
        return;
      }

      onChange(parseInt(newValue as string));
    },
    [cycleOptions.length, onChange],
  );

  const isDisabled = !filterValues.surveyGroupId;

  useEffect(() => {
    setTimeout(() => {
      // Select first cycle by default.
      const needToSetDefaultValue = !value && cycleOptions.length > 0;
      if (needToSetDefaultValue) {
        onChange(parseInt(cycleOptions[0].value as string));
      }
    }, 0);
  }, [cycleOptions, onChange, value]);

  return (
    <CycleSelection
      stateValue={value}
      onChangeCallback={handleCycleSelection}
      options={cycleOptions}
      isDisabled={isDisabled}
    />
  );
};
